<template>
  <div class="serveBindingManage">
    <ds-header title="模块管理"></ds-header>
    <a-form layout="inline">
      <a-form-item label="所属项目：">
        <a-select
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
          style="width: 200px"
          placeholder="请选择"
          v-model="searchForm.projectId"
        >
          <a-select-option v-for="item in projectName" :key="item.id" :value="item.id">
            {{ item.project_name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="模块名称：">
        <a-input v-model.trim="searchForm.moduleName" placeholder="请输入模块名称" class="inputClass" />
      </a-form-item>
      <a-form-item label="模块位置：">
        <a-select
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
          style="width: 200px"
          placeholder="请选择"
          v-model="searchForm.pagePosition"
        >
          <a-select-option v-for="item in pagePositionList" :key="item.id" :value="item.id">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <span>
        <a-button type="primary" @click="search" style="margin-top: 3px"> <a-icon type="search" />查询 </a-button>
        <a-button style="margin-left: 15px" @click="resetSearchForm">重置</a-button>
      </span>
    </a-form>
    <div style="padding-top: 15px">
      <a-button type="primary" @click="addModular()"> <a-icon type="plus" /> 新增 </a-button>
    </div>
    <div style="padding-top: 15px">
      <a-table
        :rowKey="(record, index) => index"
        :columns="table.columns"
        :data-source="table.dataInfo"
        :pagination="table.pagination.total ? table.pagination : false"
        @change="pageChange"
        bordered
        :scroll="{ x: 1500 }"
      >
        <span slot="iconUrl" slot-scope="text, record" class="action">
          <div class="imgContainer">
            <img :src="record.iconUrl" v-if="record.iconUrl"/>
          </div>
        </span>
        <span slot="action" slot-scope="text, record" class="action">
          <a-button class="btnClass" type="link" @click="view(record)"> 查看 </a-button>
          <a-button class="btnClass" type="link" @click="amend(record)"> 编辑 </a-button>
          <a-button class="btnClass" type="link" @click="restart(record)">
            <span v-if="record.status == 1">启用</span>
            <span v-else>禁用</span>
          </a-button>
          <a-button class="btnClass" type="link" @click="del(record)"> 删除 </a-button>
        </span>
      </a-table>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment"
import * as api from '@/api/modularManagement'

export default {
  name: "modularManagement",
  components: {

  },
  data() {
    return {
      searchForm: {
        moduleName: undefined,
        projectId: undefined,
        pagePosition: undefined,
      },
      // 项目名称
      projectName: [],
      pagePositionList: [{id: 0, name: "首页"},{id: 1, name: "食住行"},{id: 2, name: "无忧创业"},{id: 3, name: "我的权益"}],
      table: {
        dataInfo: [],
        columns: [
          {
            title: "所属项目",
            dataIndex: "projectName",
            key: "projectName",
          },
          {
            title: "模块图标",
            dataIndex: "iconUrl",
            key: "iconUrl",
            scopedSlots: { customRender: "iconUrl" },
            width: 112,
            align: "center",
          },
          {
            title: "模块名称",
            dataIndex: "moduleName",
            key: "moduleName",
          },
          {
            title: "页面位置",
            dataIndex: "pagePosition",
            key: "pagePosition",
            customRender(text) {
              return text == 0 ? "首页" : text == 1 ? "食住行" : text == 2 ? "无忧创业" : "我的权益";
            },
          },
          {
            title: "展示顺序",
            dataIndex: "sort",
            key: "sort",
          },
          {
            title: "状态",
            dataIndex: "status",
            key: "status",
            customRender(text) {
              return text == 1 ? "禁用" : "启用";
            },
          },
          {
            title: "更新时间",
            dataIndex: "gmtUpdate",
            key: "gmtUpdate",
            customRender(text) {
              return text ? moment(text).format("YYYY-MM-DD HH:mm:ss") : "-";
            },
          },
          {
            title: "操作",
            key: "action",
            width: "200px",
            className: "action-ql-list",
            scopedSlots: { customRender: "action" },
          },
        ],
        //分页数据
        pagination: {
          showSizeChanger: true,
          current: 1,
          pageSize: 10,
          total: 0,
          showQuickJumper: true,
          showTotal: (total) => {
            return `共 ${total} 条`;
          },
        },
      },
    };
  },
  created() {
    this.searchFormList();
    this.projectNameList();
  },
  methods: {
    // 搜索
    search() {
      this.table.pagination.current = 1;
      this.searchFormList();
    },

    // 重制
    resetSearchForm() {
      this.table.pagination.current = 1;
      this.table.pagination.pageSize = 10;
      this.searchForm = this.$options.data.call(this).searchForm;
      this.searchFormList();
    },

    // 新增
    addModular() {
      this.$router.push({
        path: "/modularManagement/add",
        query: {
          type: "add",
        },
      });
    },

    // 查看
    view(record) {
      var id = record.id;
      this.$router.push({
        path: "/modularManagement/add",
        query: {
          id: id,
          type: "view",
        },
      });
    },
    // 修改
    amend(record) {
      var id = record.id;
      this.$router.push({
        path: "/modularManagement/add",
        query: {
          id: id,
          type: "update",
        },
      });
    },

    // 启用禁用
    restart(record) {
      let that = this;
      if(record.status == 1) {
        var title = "确定启用该 【 "+record.moduleName+" 】 数据吗？"
        var status = 0;
      } else {
        var title = "确定禁用该 【 "+record.moduleName+" 】 数据吗？"
        var status = 1;
      }

      this.$confirm({
        title: title,
        onOk() {
          var id = record.id;
          api.modularRestart(id, status).then((res) => {
            if (res.code === "200") {
              that.$message.success("操作成功");
              that.table.pagination.current = 1;
              that.searchFormList();
            } else {
              that.$message.error("操作失败");
            }
          });
        },
        onCancel() {
          console.log("Cancel");
        },
        class: "test",
      });
    },

    // 删除
    del(record) {
      let that = this;
      this.$confirm({
        title: "确定要删除该 【 "+record.moduleName+" 】 数据吗？",
        onOk() {
          var id = record.id;
          api.modularDel(id).then((res) => {
            if (res.code === "200") {
              that.$message.success("操作成功");
              that.table.pagination.current = 1;
              that.searchFormList();
            } else {
              that.$message.error("操作失败");
            }
          });
        },
        onCancel() {
          console.log("Cancel");
        },
        class: "test",
      });
    },

    // 列表
    async searchFormList() {
      var data = {};
      data.moduleName = this.searchForm.moduleName
      data.projectId = this.searchForm.projectId
      data.pagePosition = this.searchForm.pagePosition
      data.page = this.table.pagination.current;
      data.size = this.table.pagination.pageSize
      const res = await api.modularList(data);
      if (res.code == 200) {
        this.table.dataInfo = res.data.appModuleList;
        this.table.pagination.total = res.data.count;
      }

    },

    // 项目列表
    async projectNameList() {
      const res = await api.projectName();
      if (res.code == 200) {
        this.projectName = res.data.items;
      }
    },

    //分页操作
    pageChange(option) {
      this.table.pagination.current = option.current;
      this.table.pagination.pageSize = option.pageSize;
      this.searchFormList();
    },
  },
};
</script>

<style lang="scss" scoped>
.btnClass {
  padding: 0px;
  padding-right: 5px;
}
.action a {
  color: #1890ff;
  margin-right: 15px;
}
.action a:hover {
  color: #40a9ff;
}
.inputClass {
  width: 200px;
}
.imgContainer {
  width: 80px;
  height: 80px;
  text-align: center;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
